import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import useLoginRequest from '../../requests/LoginRequest';
import LoaderButton from '../common/LoaderButton';
import LoginFormattedMessages from '../../messages/LoginFormattedMessages';

const MfaVerification = ({
  challenge,
  session,
  email,
  open,
  onVerified,
  onClose,
  errorHandler,
}) => {
  const [verificationCode, setVerificationCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [rememberDevice, setRememberDevice] = useState(false);
  const [message, setMessage] = useState('');

  const { verifyMfa, resendMfa } = useLoginRequest();

  const resendCode = async () => {
    await resendMfa(session, challenge, email, errorHandler);
    setMessage(LoginFormattedMessages.mfaVerificationCodeSent);
  };

  const verify = async () => {
    setIsLoading(true);
    setError(null);
    const result = await verifyMfa(
      verificationCode,
      session,
      challenge,
      email,
      rememberDevice,
      errorHandler
    );
    if (result.ok) {
      onVerified(await result.json());
    } else {
      setError(true);
    }
    setIsLoading(false);
  };

  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>{LoginFormattedMessages.mfaVerificationTitle}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          {challenge === 'SMS_MFA' && (
            <Typography>{LoginFormattedMessages.mfaVerificationSms}</Typography>
          )}
          {challenge === 'EMAIL_MFA' && (
            <Typography>
              {LoginFormattedMessages.mfaVerificationEmail}
            </Typography>
          )}
          {challenge === 'SOFTWARE_TOKEN_MFA' && (
            <Typography>
              {LoginFormattedMessages.mfaVerificationSoftwareToken}
            </Typography>
          )}
          <TextField
            id="verificationCode"
            name="verificationCode"
            label="Verification Code"
            type="number"
            fullWidth
            autoFocus
            onChange={(e) => setVerificationCode(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                verify();
              }
            }}
          />

          {error && (
            <Typography color="error">
              {LoginFormattedMessages.mfaVerificationError}
            </Typography>
          )}

          {challenge !== 'SOFTWARE_TOKEN_MFA' && (
            <Tooltip
              title={
                LoginFormattedMessages.mfaVerificationRememberDeviceTooltip
              }
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={rememberDevice}
                    onChange={(e) => setRememberDevice(e.target.checked)}
                  />
                }
                label={LoginFormattedMessages.mfaVerificationRememberDevice}
              />
            </Tooltip>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={2} alignItems="center">
          {challenge !== 'SOFTWARE_TOKEN_MFA' && (
            <>
              {message && <Typography>{message}</Typography>}

              <Button variant="text" onClick={resendCode}>
                {LoginFormattedMessages.mfaVerificationResendCode}
              </Button>
            </>
          )}

          <LoaderButton
            isLoading={isLoading}
            text={LoginFormattedMessages.mfaVerificationVerify}
            loadingText={LoginFormattedMessages.mfaVerificationVerifyLoading}
            variant="contained"
            color="secondary"
            onClick={verify}
          />
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default MfaVerification;
